import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX, FiFacebook, FiTwitter, FiInstagram } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = ['HOME', 'PAGES', 'BLOG', 'SHOP', 'ELEMENTS'];

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="gradient-bg text-white py-4 px-6 fixed w-full top-0 z-50"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="text-2xl font-bold">
          Creativa
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <a 
              key={item}
              href="#" 
              className="text-sm font-medium hover:text-orange-400 transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        {/* Social Icons & Contact Button */}
        <div className="hidden md:flex items-center space-x-4">
          <SafeIcon icon={FiFacebook} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
          <SafeIcon icon={FiTwitter} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
          <SafeIcon icon={FiInstagram} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
          <button className="bg-orange-500 hover:bg-orange-600 px-6 py-2 rounded-full text-sm font-medium transition-colors">
            CONTACT
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden mt-4 pb-4"
        >
          <nav className="flex flex-col space-y-3">
            {navItems.map((item) => (
              <a 
                key={item}
                href="#" 
                className="text-sm font-medium hover:text-orange-400 transition-colors"
              >
                {item}
              </a>
            ))}
          </nav>
          <div className="flex items-center space-x-4 mt-4">
            <SafeIcon icon={FiFacebook} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
            <SafeIcon icon={FiTwitter} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
            <SafeIcon icon={FiInstagram} className="w-5 h-5 hover:text-orange-400 cursor-pointer transition-colors" />
            <button className="bg-orange-500 hover:bg-orange-600 px-6 py-2 rounded-full text-sm font-medium transition-colors">
              CONTACT
            </button>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;